import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, EmailAuthProvider } from "firebase/auth";

// TODO: Replace with your app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAH8aKY0t9Z1Rz7E_nftqtwGMSzG6fXUKw",
  authDomain: "codex-vitae-hackathon.firebaseapp.com",
  projectId: "codex-vitae-hackathon",
  storageBucket: "codex-vitae-hackathon.firebasestorage.app",
  messagingSenderId: "425886683509",
  appId: "1:425886683509:web:add89abc0b41924fd5833c"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const emailProvider = new EmailAuthProvider(); // If you use email link, etc.

export default app;